<template>
    <div class="container pt-6 pb-24">
        <iframe
            src="https://sps.hospitalsearch.ahsa.com.au/"
            title="Hospital provider search feature and map"
            width="100%"
            height="850"
        />
    </div>
</template>

<script>
export default {
    mounted() {}
};
</script>
